import React, { useEffect, useState } from 'react';
import AdminHeading from '../Heading/AdminHeading';
import AdminBreadCrump from '../Heading/AdminBreadCrump';
import { Icon } from '@iconify/react';
import { Box } from '@mui/material';

import '../../PagesStyles/AdminMasters.css';
import { TbCircleNumber1 } from 'react-icons/tb';
import {
  a100,
  a104,
  a107,
  a108,
  a109,
  a110,
  a111,
  a112,
  a119,
  a120,
  a121,
  a122,
  a123,
  a124,
  a125,
  a126,
  a127,
  a128,
  a129,
  a130,
  a131,
  a132,
  a133,
  a137,
  a138,
  a139,
  a18,
  a191,
  a192,
  a193,
  a194,
  a195,
  a196,
  a35,
  a7,
  a95,
  a96,
  a97,
  a98,
  a99,
} from '../../../Api/RootApiPath';
import { useSelector } from 'react-redux';
import { RiListUnordered, RiPlayListAddLine } from 'react-icons/ri';
import AlertMessage from '../../../Other Functions/AlertMessage';
import CustomerTable from 'Components/support/customervendor/customer';
import style from '../../LatestPages/AddNewCustomer.module.css';
import toast from 'react-hot-toast';

export default function AddDiamondAttributes() {
  const [active, setActive] = useState('AddNew');
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState('');
  const [messageToShow, setMessageToShow] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState('');

  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    DiamondAttribute: '',
    DiamondValue: '',
    CompanyId: 0,
    BranchId: 0,
    CounterId: 0,
    EmployeeId: 0,

    OldEntry: false,
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  const [allCategoriesList, setAllCategoriesList] = useState([]);
  const [allProductsList, setAllProductsList] = useState([]);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;
  const companyId = adminLoggedIn.CompanyId;
  const branchId = adminLoggedIn.BranchId;
  const counterId = adminLoggedIn.CounterId;
  const employeeId = adminLoggedIn.EmployeeId;

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log('Searching for:', searchTerm);
  };

  const handleList = () => {
    // Custom logic for the List button
    console.log('List button clicked');
    setActive('List');
  };

  const handlenew = () => {
    setActive('AddNew');
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a194, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive('addNew');
        document
          .getElementById('addCategoryListTitle')
          .classList.add('activeCategoryTitle');
        document
          .getElementById('addCategoryListLogo')
          .classList.add('activeCategoryLogo');
        document.getElementById('addCategoryListTitle').click();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategory();
  }, []);
  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Branch First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Departments First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllDepartments();
  }, []);

  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Roles First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllRoles();
  }, []);

  const fetchAllCategoriesList = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a125, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllCategoriesList(data);
      } else {
        // alert("Please Add Category First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategoriesList();
  }, []);

  const fetchAllProductsList = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a128, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllProductsList(data);
      } else {
        // alert("Please Add Product First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllProductsList();
  }, []);

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    if (name == 'DiamondValue') {
      setNewCategory({ ...newCategory, [name]: value.toUpperCase() });
    } else {
      setNewCategory({ ...newCategory, [name]: value });
    }
  };

  console.log(newCategory, 'newCategory');
  console.log(newCategory, 'newCategory');

  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      ClientCode: clientCode,

      DiamondAttribute: newCategory.DiamondAttribute,
      DiamondValue: newCategory.DiamondValue,

      CompanyId: companyId ? companyId : 0,
      BranchId: branchId ? branchId : 0,
      CounterId: counterId ? counterId : 0,
      EmployeeId: employeeId ? employeeId : 0,

      OldEntry: false,

      ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
    };
    console.log(formData, 'formData to send');
    try {
      const response = await fetch(
        !newCategory.OldEntry ? a195 : a196,
        // a96,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      console.log('DATAres : ', data);
      fetchAllCategory();
      setActive('List');
      setNewCategory({
        DiamondAttribute: '',
        DiamondValue: '',
        CompanyId: 0,
        BranchId: 0,
        CounterId: 0,
        EmployeeId: 0,

        OldEntry: false,
      });
      if (data.Message) {
        // alert(data.message);
        // setMessageType("error");
        toast.error(data.Message, {
          duration: 3000,
          position: 'top-center',
        });
        // setShowError(true);
        setActive('AddNew');
      } else {
        // setMessageType("success");
        toast.success('Diamond Attribute Added Successfully', {
          duration: 3000,
          position: 'top-center',
        });
        // setShowError(true);
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);

  const handleEditData = (data) => {
    console.log(data, 'data');
    console.log(data, 'data');
    console.log(data, 'data');
    setNewCategory({ ...data, OldEntry: true });
    setActive('AddNew');
  };

  const columns = [
    { key: 'serialNumber', label: 'S.No', type: 'read', priority: 2 },
    {
      key: 'DiamondAttribute',
      label: 'Diamond Attribute',
      type: 'read',
      priority: 1,
    },

    {
      key: 'DiamondValue',
      label: 'Diamond Value',
      type: 'read',
      priority: 1,
    },
  ];

  const handleResetField = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
      inputRef9,
      inputRef10,
      inputRef11,
      inputRef12,
      inputRef13,
      inputRef14,
      inputRef15,
      inputRef16,
      inputRef17,
      inputRef18,
      inputRef19,
      inputRef20,
      inputRef21,
      inputRef22,
    ];

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === 'SELECT') {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ''; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };

  console.log(allCategories)
  return (
    <div>
      <AdminHeading />
      <div style={{ paddingTop: '130px' }}>
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={'Add Diamond Attributes'}
          companyName={'Loyalstring'}
          module={'Settings'}
          page={'Diamond Attributes'}
        />
      </div>

      <div style={{ padding: '16px' }}>
        {active == 'List' ? (
          <>
            <div className={style['white-space']}>
              <div className={style['icon-div']}>
                <div className={style['search-container']}>
                  <input
                    type="text"
                    value={searchInput}
                    onChange={handleSearchChange}
                    placeholder="Search..."
                    className={style['serach-input']}
                  />
                  <button
                    style={{ margin: 0 }}
                    className={style['search-btn']}
                    onClick={handleSearchSubmit}
                  >
                    <Icon style={{ fontSize: '20px' }} icon="mdi:magnify" />
                  </button>
                </div>

                <Icon
                  style={{
                    fontSize: '28px ',
                    color: '#0077d4',
                    cursor: 'pointer',
                  }}
                  icon="bx:export"
                />

                <button
                  // style={{ width: "30%" }}
                  className={style['custom-btn']}
                >
                  <Icon style={{ fontSize: '24px ' }} icon="ic:outline-print" />
                  Print
                </button>
                <button
                  onClick={handlenew}
                  style={{ margin: 0 }}
                  className={style['custom-btn']}
                >
                  New
                  <Icon icon="mdi:plus" width="24" height="24" />
                </button>
              </div>
            </div>

            <CustomerTable
              columns={columns}
              allCategories={allCategories}
              handleEditData={handleEditData}
              searchInput={searchInput}
              setSearchInput={setSearchInput}

              // title={"All Customers"}
            />
          </>
        ) : (
          <>
            <div className={style.adminAddCategoryMainBox}>
              <div className={style.adminAddCategoryInnerBox}>
                <div className={style.adminCategoryAddCategoryMainBox}>
                  <p style={{ margin: '0' }}>Add New Diamond Attribute</p>
                  <form style={{ width: '100%' }} onSubmit={addNewCategory}>
                    <div
                      style={{
                        gridTemplateColumns: 'repeat(1,2fr)',
                        columnGap: '30px',
                        margin: '0px 0px',
                        padding: 'var(--Space-0, 0px) 24px',
                      }}
                      // className="adminCategoryAddCategoryInnerBox"
                    >
                      {/* <Box sx={{ width: "95%", margin: "0 auto" }}> */}
                      <div
                        style={{
                          gridTemplateColumns: 'repeat(4,1fr)',
                          columnGap: '40px',
                          margin: '15px 0px',
                        }}
                        className="adminCategoryAddCategoryInnerBox"
                      >
                        <label>
                          Diamond Attribute <sup>*</sup>
                        </label>
                        <select
                          name="DiamondAttribute"
                          value={newCategory.DiamondAttribute}
                          onChange={handleNewCategoryChange}
                          required="required"
                        >
                          <option value={''}>Select An Option</option>
                          <option value={'DiamondClarity'}>
                            Diamond Clarity
                          </option>
                          <option value={'DiamondColour'}>
                            Diamond Colour
                          </option>
                          <option value={'DiamondCut'}>Diamond Cut</option>
                          <option value={'DiamondShape'}>Diamond Shape</option>
                          <option value={'DiamondSettingType'}>
                           Diamond Setting Type
                          </option>
                          <option value={'DiamondSleve'}>
                           Diamond Sleve
                          </option>
                          <option value={'DiamondSize'}>
                           Diamond Size
                          </option>
                          <option value={'DiamondSleveGroup'}>
                           Diamond Sleve Group
                          </option>
                        </select>
                        <label>
                          Diamond Value <sup>*</sup>
                        </label>
                        <input
                          name="DiamondValue"
                          value={newCategory.DiamondValue}
                          onChange={handleNewCategoryChange}
                          type="string"
                          required="required"
                          style={{ border: '1px solid #ddd' }}
                        />{' '}
                        {/*changed the type of Diamond value input field from number to string by Dnyaneshwar on 28/01/2025*/}
                      </div>
                      {/* </Box> */}
                    </div>
                    {!loading ? (
                      <div className={style['btn-container']}>
                        <button className={style.buttons} type="submit">
                          <Icon
                            icon="ic:baseline-check"
                            width="24"
                            height="24"
                          />{' '}
                          Submit
                        </button>
                        <button
                          className={style.buttons}
                          style={{
                            backgroundColor: '#fff',
                            color: '#0077d4',
                            border: '1px solid #0077d4',
                          }}
                          type="button"
                          onClick={handleResetField}
                        >
                          <Icon
                            style={{ color: '#0077d4' }}
                            icon="ix:reset"
                            width="24"
                            height="24"
                          />
                          Reset
                        </button>
                        <button
                          className={style.buttons}
                          type="button"
                          onClick={handleList}
                        >
                          <Icon
                            icon="fluent:list-rtl-16-filled"
                            width="24"
                            height="24"
                          />
                          List
                        </button>
                      </div>
                    ) : null}
                  </form>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
